import {Map, GoogleApiWrapper} from 'google-maps-react';
import React, { Component } from 'react';

export class MapContainer extends Component {
   render() {
      return (
         <Map google={this.props.google} zoom={14}></Map>
      );
   }
}

export default GoogleApiWrapper({
   apiKey: (process.env.REACT_APP_GOOGLE_MAPS_API)
})(MapContainer)